import { defineComponent as _defineComponent } from 'vue'
import { Link } from '@inertiajs/vue2';
import IconLogo from '@/components/icons/IconLogo.vue';
import SetNewPasswordForm from '@/components/SetNewPasswordForm.vue';


import MainLayout from '@/layouts/MainLayout.vue';
import SideLayout from '@/layouts/SideLayout.vue';

const __default__ = {
    layout: [MainLayout, SideLayout],
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'SetNewPasswordView',
  props: {
    token: { default: undefined },
    email: { default: undefined }
  },
  setup(__props: any) {



return { __sfc: true,IconLogo, SetNewPasswordForm }
}

})